import { Injectable, inject } from '@angular/core';

import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';

/**
 * Component timer/scroll state threaded into the custom-event builder.
 *
 * These values are owned by USGenericComponent (`this.initTimer`,
 * `this.scrollEvents`, both TOUC-982 fields) and are passed IN rather than held
 * by the service — the service stays stateless. `initTimer` is the epoch-ms
 * timestamp captured when the sell page initialised; `scrollEvents` is the
 * running scroll counter.
 */
export interface UpsellAnalyticsTimingState {
  initTimer: number;
  scrollEvents: number;
}
@Injectable({ providedIn: 'root' })
export class UpsellAnalyticsService {
  private readonly funnelProvider = inject(FunnelSettingsProvider);

  sendCustomEvent(event_type: string, timing: UpsellAnalyticsTimingState, data?: unknown): void {

    try { // TOUC-982

      // [TOUC-5700]
      if (document.location.search && document.location.search.length > 0 && typeof URLSearchParams === 'function') {
        let searchParams = new URLSearchParams(document.location.search);
        if (searchParams && searchParams.get("utm_campaign") && (searchParams.get("utm_campaign") as string).indexOf("email") > -1) {
          console.log("[GH] not saving event " + event_type + " for email campaign " + searchParams.get("utm_source"), data);
          return;
        }
      }

      if (typeof data === 'undefined') {
        let regularPrice: Element | string | null = document.querySelector('.regularPrice') ? document.querySelector('.regularPrice') : document.querySelector('.description_wrapper_regularPrice');
        let instantSavings: Element | string | null = document.querySelector('.instantSavings') ? document.querySelector('.instantSavings') : document.querySelector('.description_wrapper_instantSavings');
        let yourPrice: Element | string | null = document.querySelector('.yourPrice') ? document.querySelector('.yourPrice') : document.querySelector('.description_wrapper_yourPrice');

        if (!regularPrice) regularPrice = document.querySelector('.reg-price');
        if (!instantSavings) instantSavings = document.querySelector('.instant-savings');
        if (!yourPrice) yourPrice = document.querySelector('.special-price');

        if (!regularPrice) regularPrice = document.querySelector('.productDesc2');
        if (!instantSavings) instantSavings = document.querySelector('.productDesc3');
        if (!yourPrice) yourPrice = document.querySelector('.productPrice');


        if (regularPrice) regularPrice = (regularPrice as Element).textContent;
        if (instantSavings) instantSavings = (instantSavings as Element).textContent;
        if (yourPrice) yourPrice = (yourPrice as Element).textContent;
        let productinfo = yourPrice + ', ' + regularPrice + ', ' + instantSavings;
        if (productinfo.length > 180) productinfo = productinfo.substring(0, 180);
        data = {
          time: (new Date().getTime() - timing.initTimer) / 1000,
          scrolls: timing.scrollEvents,
          productinfo: productinfo
        };
      }
      const seg = document.location.pathname.replace(/\//g, '');
      const component = this.funnelProvider.getComponent(seg);
      if (typeof component !== 'undefined') {
        //console.log("sending Custom stats for " + component.name, data)
        this.funnelProvider.sendCustomStats(
          event_type,
          { segment: seg, name: component?.path, data: data }
        );
      }
    } catch (e) {
      console.log('TOUC-982 error:', e);
    }
  }
}
